import { Swiper, Navigation } from 'swiper';

export default class Numbers {
    constructor(query) {
        this.elems = [...document.querySelectorAll(query)];
        if (!this.elems.length) return;

        this.query = query;
        this.instances = new Map();

        this.handle = this.handle.bind(this);

        this.handle();
        window.addEventListener('load', this.handle);
        window.addEventListener('resize', this.handle);
    }

    handle() {
        this.elems.forEach((elem) => {
            const slider = elem.querySelector(`${this.query}__slider`);
            if (!slider) return;

            const instance = this.instances.get(slider);
            const isMobile = window.matchMedia('(max-width: 767px)').matches;

            if (!isMobile) {
                if (instance) {
                    instance.destroy(true, true);
                    this.instances.delete(slider);
                }

                return;
            }

            if (instance) {
                instance.update();
                return;
            }

            const swiper = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 16,
                observer: true,
                observeParents: true,
                watchOverflow: true,
                navigation: {
                    prevEl: elem.querySelector(`${this.query}__navigation-prev`),
                    nextEl: elem.querySelector(`${this.query}__navigation-next`),
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                },
            });

            this.instances.set(slider, swiper);
        });
    }
}